export default "__VITE_ASSET__9a2d9191__"